class ProductReviewsVisibility extends HTMLElement {
  connectedCallback () {
    if (this.initialized) return

    this.initialized = true
    this.reviewsWidgetWrapper = this.querySelector('[data-product-reviews-el="reviews"]')
    this.carouselWrapper = this.querySelector('[data-product-reviews-el="carousel"]')

    if (!this.reviewsWidgetWrapper || !this.carouselWrapper) return

    this.hideCarousel()
    this.observeWidget()
    this.updateCarouselVisibility()
  }

  disconnectedCallback () {
    this.disconnectObserver()
  }

  observeWidget () {
    this.disconnectObserver()

    this.observer = new MutationObserver(() => {
      this.updateCarouselVisibility()
    })

    this.observer.observe(this.reviewsWidgetWrapper, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    })
  }

  updateCarouselVisibility () {
    const widgetState = this.getWidgetState()

    if (widgetState === 'has-reviews') {
      this.showCarousel()
      this.disconnectObserver()

      return
    }

    if (widgetState === 'empty') {
      this.applyCustomEmptyText()
      this.hideCarousel()
      this.disconnectObserver()

      return
    }

    this.hideCarousel()
  }

  getWidgetState () {
    const widget = this.reviewsWidgetWrapper.querySelector('.oke-w-reviews')
    const emptyState = this.reviewsWidgetWrapper.querySelector('.oke-state-empty')

    if (emptyState) return 'empty'

    if (widget && widget.hasAttribute('data-oke-rendered')) {
      return 'has-reviews'
    }

    return null
  }

  applyCustomEmptyText () {
    const customText = this.dataset.customNoReviewsText

    if (!customText) return

    const emptyTextElement = this.reviewsWidgetWrapper.querySelector('.oke-state-empty-text')

    if (emptyTextElement) {
      emptyTextElement.innerHTML = customText
    }
  }

  showCarousel () {
    this.carouselWrapper.removeAttribute('hidden')
  }

  hideCarousel () {
    this.carouselWrapper.setAttribute('hidden', '')
  }

  disconnectObserver () {
    if (!this.observer) return

    this.observer.disconnect()
    this.observer = null
  }
}

if (!customElements.get('product-reviews-visibility')) {
  customElements.define('product-reviews-visibility', ProductReviewsVisibility)
}
